import { useSettingsChipTone } from '~/components/AiSearchChips/settingsChipTone';
import { useLocaleKeys } from '~/i18n';
import { useDraftsChipConnector } from './draftsChipConnector';
export const useDraftsSettingsGrammar = ()=>{
    const { t } = useLocaleKeys('proposal.draftsDashboard.aiSearch');
    const connector = useDraftsChipConnector();
    const tone = useSettingsChipTone();
    return {
        tone,
        connector,
        apply: t.applyButton(),
        valueSet: t.settingsValueSet(),
        fields: {
            requirePaymentMethod: {
                bi: 'drafts_ai_search_chip_settings_require_payment_method',
                label: t.settingsPaymentMethodLabel(),
                required: t.settingsPaymentMethodRequired(),
                notRequired: t.settingsPaymentMethodNotRequired()
            },
            creditCardFeesPaidBy: {
                bi: 'drafts_ai_search_chip_settings_credit_card_fees',
                label: t.settingsCcFeesLabel(),
                paidByClient: t.settingsCcFeesPaidByClient(),
                paidByServiceProvider: t.settingsCcFeesPaidByServiceProvider()
            },
            expirationDate: {
                bi: 'drafts_ai_search_chip_remove_settings_expirationDate',
                label: t.settingsExpirationDateLabel(),
                never: t.settingsExpirationNeverLabel(),
                within: (days)=>t.settingsExpirationWithin({
                        days
                    }),
                after: (days)=>t.settingsExpirationAfter({
                        days
                    }),
                inDays: (days)=>t.settingsExpirationIn({
                        days
                    }),
                isSet: t.settingsExpirationSet()
            },
            amendmentsApprovalMethod: {
                bi: 'drafts_ai_search_chip_remove_settings_amendmentsApprovalMethod',
                label: t.settingsAmendmentsFieldLabel(),
                auto: t.settingsApprovalApprovedAuto(),
                autoAfter: (days)=>t.settingsApprovalApprovedAutoAfter({
                        days
                    }),
                manual: t.settingsApprovalApprovedManual()
            },
            outOfScopeChargesApprovalMethod: {
                bi: 'drafts_ai_search_chip_remove_settings_outOfScopeChargesApprovalMethod',
                label: t.settingsOosApprovalLabel(),
                auto: t.settingsApprovalAuto(),
                autoAfter: (days)=>t.settingsApprovalAutoAfter({
                        days
                    }),
                manual: t.settingsApprovalManual()
            },
            termsOfService: {
                bi: 'drafts_ai_search_chip_remove_settings_terms_of_service',
                exists: t.settingsTermsOfServiceExists(),
                name: {
                    bi: 'drafts_ai_search_chip_settings_terms_of_service',
                    label: t.settingsTermsOfServiceLabel(),
                    contains: (value)=>t.settingsTermsOfServiceContains({
                            value
                        })
                }
            }
        }
    };
};
